import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";
import CaseNotes from "./notes";

export * from "./notes";

export async function getCases(options = {}, requestOptions = {}) {
  const { data_only = true, ...rest } = options;

  if (data_only) {
    return (await httpGet("/cases", rest, requestOptions))?.data || [];
  }
  return await httpGet("/cases", rest, requestOptions);
}

async function query(query) {
  return await httpPost("/cases/query", query);
}

async function exportCaseList(query) {
  return await httpPost("/cases/export", query);
}

export async function getCaseNumbers(params = {}) {
  return await httpGet(`/cases/case-numbers`, params);
}

export async function createCase(values) {
  return await httpPost("/cases", values);
}

export async function caseNumberExists(params = {}) {
  const result = await httpGet(`/cases/case-numbers`, params);

  if (!result) return false;
  return result?.length > 0;
}

export async function updateCase(id, values) {
  return await httpPatch(`/cases/${id}`, values);
}

export async function deleteCase(id) {
  return await httpDelete(`/cases/${id}`);
}

export async function getCaseActivity(values = { case_id: null, limit: null }) {
  if (typeof values.limit == "undefined")
    return await httpGet(`/cases/${values.case_id}/activity`);
  else
    return await httpGet(
      `/cases/${values.case_id}/activity?limit=${values.limit}`
    );
}

export async function getCaseNumberFormat() {
  return await httpGet(`/cases/format`);
}

export async function updateCaseNumberFormat(values) {
  return await httpPatch(`/cases/format`, values);
}

// CUSTOM FIELDS

async function createCaseCustomField(
  values = { field_name: null, is_required: null, type_id: null }
) {
  return await httpPost(`/cases/attributes/field`, values);
}

export async function updateCaseCustomField(id, values = {}) {
  return await httpPost(`/cases/attributes/field/${id}`, values);
}

export async function deleteCaseCustomField(id) {
  return httpDelete(`/cases/attributes/field/${id}`);
}

async function metrics(values = {}) {
  return await httpGet(`/cases/metrics`, values);
}

const CasesApi = {
  query,
  exportCaseList,
  getCases,
  getCaseNumbers,
  updateCase,
  caseNumberExists,
  getCaseActivity,
  createCase,
  deleteCase,
  getCaseNumberFormat,
  updateCaseNumberFormat,
  CaseNotes: CaseNotes,
  createCaseCustomField,
  updateCaseCustomField,
  deleteCaseCustomField,
  metrics,
};

export default CasesApi;
